import React from 'react';
import classNames from 'classnames';
import { Button, Sprite } from '@agissc/ktag-map';
import { useTranslation } from 'react-i18next';

interface SearchResultItemProps {
  label: string | React.ReactNode;
  resultType: string;
  isSelected: boolean;
  onClick: () => void;
  children?: React.ReactNode;
  title?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isPublic?: boolean;
}

const SearchResultItem = ({
  label,
  resultType,
  isSelected,
  onClick,
  children,
  title,
  onMouseEnter,
  onMouseLeave,
  isPublic = true,
}: SearchResultItemProps) => {
  const { t } = useTranslation('agisviewer');

  return (
    <div
      title={title}
      className={classNames('result-item', {
        'result-item--active': isSelected,
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Button onClick={onClick} additionalClassNames="result-item__button">
        <div className="result-item__label">{label}</div>
        <div className="result-item__type-wrapper">
          <div className="result-item__type">{resultType}</div>
          <div title={t('restricted_layer')}>
            {!isPublic && (
              <Sprite id="lock-closed" additionalClassNames="result-item_type-icon" />
            )}
          </div>
        </div>
      </Button>
      <div
        className={classNames('result_item__icon-wrapper', {
          'result_item__icon-wrapper--hide': !isSelected,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default SearchResultItem;
